import { createServiceFactory } from '@/services/factory'
import { createMockUserService } from './users.mock'
import { createHttpUserService } from './users.http'

export type { UserService } from './users.service'

export const getUserService = createServiceFactory(
  'users',
  createMockUserService,
  createHttpUserService
)
